import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from '@app/landing/landing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { LoginLayoutComponent } from '@app/landing/login-layout/login-layout.component';
import { LandingRoutingModule } from '@app/landing/landing-routing.module';
import { FootComponent } from '@app/landing/foot/foot.component';
import { PassforgotComponent } from '@app/landing/passforgot/passforgot.component';
import { LoginComponent } from "@app/landing/login/login.component";
import { MfaComponent } from "@app/landing/mfa/mfa.component";

import { SharedModule } from "@app/shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    NgbModule,
    FormsModule,
    LandingRoutingModule,
    SharedModule
  ],
	exports: [
		LandingComponent
	],
	declarations: [LandingComponent, FootComponent, LoginLayoutComponent, LoginComponent, MfaComponent, PassforgotComponent]
})
export class LandingModule { }
